import { useEffect, useMemo, useState } from 'react';
import P from '@leverege/promise';
import LayerCreatorFactory from "./layerCreators/canvas/LayerCreatorFactory.js";
import { addLayersToCollection } from "./Util.js";
const EMPTY_ARRAY = [];
export default function useCanvasOverlayViewer(props) {
  const {
    layers: pLayers,
    context
  } = props;
  const [layerDescriptors, setLayerDescriptors] = useState(EMPTY_ARRAY);
  useEffect(() => {
    const load = async () => {
      const ld = [];
      const res = await P.map(pLayers, async pLayer => {
        return LayerCreatorFactory.create(pLayer, null, {
          ...context
        });
      }, {
        handleReject: true
      });
      res.forEach(layer => {
        if (layer instanceof Error) {
          console.error(layer);
        } else {
          addLayersToCollection(layer, ld);
        }
      });
      setLayerDescriptors(ld);
    };
    load();
  }, [pLayers, context]);
  const layers = useMemo(() => {
    return layerDescriptors.sort((a, b) => {
      const sortA = a.sort || 'z';
      const sortB = b.sort || 'z';
      return sortA.localeCompare(sortB);
    }).map(l => l.layer);
  }, [layerDescriptors]);
  return {
    layers
  };
}